import { t } from "@/i18n-js/instance";
import { DimensionInput } from "../DimensionInput";

const sizingFields = [
  { name: "width", label: t("builder_ui.prop_type.styles.width") },
  { name: "height", label: t("builder_ui.prop_type.styles.height") },
  { name: "minWidth", label: t("builder_ui.prop_type.styles.min_width") },
  { name: "minHeight", label: t("builder_ui.prop_type.styles.min_height") },
  { name: "maxWidth", label: t("builder_ui.prop_type.styles.max_width") },
  { name: "maxHeight", label: t("builder_ui.prop_type.styles.max_height") },
];

export const Sizing = () => (
  <div className="grid grid-cols-2 grid-rows-3 gap-x-4 gap-y-2">
    {sizingFields.map(field => (
      <DimensionInput
        key={field.name}
        name={`styles.sizing.${field.name}`}
        label={field.label}
      />
    ))}
  </div>
);
